import React, { useState, useContext, useEffect } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { FaRegCopy } from "react-icons/fa";
import { IoCloudDownloadOutline } from "react-icons/io5";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { images } from "./ax2";
import { CartContext } from "../CartContext";
import "../imageTable.css";
import { GoMoveToTop } from "react-icons/go";

const stripePromise = loadStripe(process.env.REACT_APP_MAIN_KEY);
const ITEMS_PER_PAGE = 48;

const KidsTable = () => {
  const [hoveredImage, setHoveredImage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const cart = useContext(CartContext);
  const [email, setEmail] = useState(null);
  const [loggedIn, setLoggedIn] = useState(false);

  const handleMouseEnter = (id) => setHoveredImage(id);
  const handleMouseLeave = () => setHoveredImage(null);

  // Login detection
  useEffect(() => {
    const checkLogin = () => {
      const storedEmail = localStorage.getItem("userEmail");
      if (storedEmail) {
        setEmail(storedEmail);
        setLoggedIn(true);
      } else {
        setEmail(null);
        setLoggedIn(false);
      }
    };

    checkLogin();
    window.addEventListener("userLogin", checkLogin);
    window.addEventListener("storage", checkLogin);

    return () => {
      window.removeEventListener("userLogin", checkLogin);
      window.removeEventListener("storage", checkLogin);
    };
  }, []);

  const handleDownload = async (
    imageSrc,
    price,
    ax,
    id,
    size,
    available,
    src,
    email
  ) => {
    try {
      const stripe = await stripePromise;
      const response = await fetch(
        "https://api-shipping-28612190fdf4.herokuapp.com/strpforimg",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            imageSrc,
            price,
            ax,
            id,
            size,
            available,
            src,
            email,
          }),
        }
      );
      if (!response.ok) throw new Error("Failed to create checkout session");

      const session = await response.json();
      const result = await stripe.redirectToCheckout({ sessionId: session.id });
      if (result.error) console.error("Stripe Checkout error:", result.error);
    } catch (error) {
      console.error("Checkout process failed:", error);
    }
  };

  const handlePageChange = (newPage) => setCurrentPage(newPage);

  const filteredImages = images.filter((image) => {
    const normalizedSrc = image.main
      .split("/")
      .pop()
      .replace(/\.[^/.]+$/, "")
      .replace(/-/g, " ")
      .toLowerCase();
    const words = searchQuery.trim().toLowerCase().split(/\s+/).filter(Boolean);
    return (
      words.length === 0 || words.some((word) => normalizedSrc.includes(word))
    );
  });

  const totalPages = Math.ceil(filteredImages.length / ITEMS_PER_PAGE);
  const startIdx = (currentPage - 1) * ITEMS_PER_PAGE;
  const currentImgs = filteredImages.slice(startIdx, startIdx + ITEMS_PER_PAGE);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const addToCart = (img) => {
    cart.addOneToCart(img.id, "", "", "", img.src, "", "", "", "");
  };

  return (
    <>
    
      {!loggedIn || !email ? (
        <div
          style={{
            textAlign: "center",
            fontSize: 20,
            marginBottom: 20,
            marginTop: 5,
          }}
        >
          You need to <strong>sign in</strong> to view and download designs.
        </div>
      ) : (
        <>
          <div className="product-container" id="product-container">
            <h6>
              Available designs: <span>{filteredImages.length}</span>
            </h6>
            <div className="search-box">
              <input
                type="text"
                placeholder="What you looking for..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
          </div>

          <div style={{ width: "90%", maxWidth: "1200px", margin: "auto" }}>
            <div className="grid-container">
              {currentImgs.map((img) => (
                <div
                  key={img.id}
                  className="image-card"
                  onMouseEnter={() => handleMouseEnter(img.id)}
                  onMouseLeave={handleMouseLeave}
                    style={{
    backgroundColor: hoveredImage === img.id ? "darkgrey" : "transparent",
    transition: "background-color 0.3s ease",
  }}
                >
                  <div className="image-wrapper">
                    <img src={img.src} alt={img.alt} className="image" />

                    {hoveredImage === img.id && (
                      <>
                        {/* Download button (top left) */}
                        <button
                          onClick={() =>
                            handleDownload(
                              img.full_path,
                              img.price,
                              img.src,
                              img.id,
                              img.size,
                              img.available,
                              img.src,
                              email
                            )
                          }
                          className="download-button"
                          style={{
                            // border:"solid 1px orange",
                            maxWidth:30,
                            top: "8px",
                            left: "8px",
                            color: "red",
                            // backgroundColor: "red",
                          }}
                          title="Download"
                        >
                          <IoCloudDownloadOutline />
                        </button>

                        {/* Copy ID button */}
                        <button
                          onClick={() => {
                            navigator.clipboard
                              .writeText(img.id)
                              .then(() => console.log(`Copied ID: ${img.id}`))
                              .catch((err) =>
                                console.error("Failed to copy text: ", err)
                              );
                          }}
                          className="copy-button"
                          style={{    backgroundColor: hoveredImage === img.id ? "darkgrey" : "transparent"}}
                          title="Copy ID"
                        >
                          <FaRegCopy />
                        </button>
                      </>
                    )}
                  </div>

                  <div style={{ fontSize: "18px", textAlign: "center" }}>
                    ID: {img.id}
                  </div>
                  <div className="image-text">
                    Availability: [{img.available.join(", ")}]
                  </div>
                  <div className="image-text">Size: {img.size}</div>

                  {hoveredImage === img.id && (
                    <div className="price-tag">
                      Price: ${img.price.toFixed(2)}
                    </div>
                  )}
                </div>
              ))}
            </div>

      <div className="pagination">
        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
        >
          <img
            src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925250/my_uploads/o7m7damek0k2zanyyhcb.png"
            style={{ maxWidth: 35, marginRight: -50}}
            alt="First"
          />
        </button>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <img src="/left-arrow.png" style={{ maxWidth: 35 }} alt="Prev" />
        </button>

        <span style={{marginLeft:-10}}>
          Page {currentPage} of {totalPages}
        </span>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <img src="/right-arrow.png" style={{ maxWidth: 35 , marginLeft:-15}} alt="Next" />
        </button>

        <button
          style={{ backgroundColor: "white" }}
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages}
        >
          <img
            src="https://res.cloudinary.com/dcuturlmb/image/upload/v1759925251/my_uploads/ocislq4muj6wqc5aks2k.png"
            style={{ maxWidth: 35, marginLeft: -50 }}
            alt="Last"
          />
        </button>
      </div>

            <div>
              <a
                href="#product-container"
                style={{ textDecoration: "none", color: "black" }}
              >
                <p style={{ fontSize: "30px", fontWeight: "bold" }}>
                  <GoMoveToTop />
                </p>
                <p style={{ marginTop: -25 }}>Top</p>
              </a>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default KidsTable;
